/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Security_No_Agent_Passkeys_DescriptionInputs */



/**
* | output |
* | --- |
* | "Your AI agent has not signed up for anything yet." |
*
* @param {Profile_Security_No_Agent_Passkeys_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const profile_security_no_agent_passkeys_description = /** @type {((inputs?: Profile_Security_No_Agent_Passkeys_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Security_No_Agent_Passkeys_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Ihre KI hat sich noch nirgends registriert.")
	return /** @type {LocalizedString} */ ("Your AI agent has not signed up for anything yet.")
});